// extracted by mini-css-extract-plugin
module.exports = {"secondary-link":"SecondaryLink_secondary-link__KXg_x","hover":"SecondaryLink_hover__bnp9a","label":"SecondaryLink_label__JM8jb","icon":"SecondaryLink_icon__p8NMJ"};